import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HowItWorksSection.css';

function HowItWorksSection() {
  const navigate = useNavigate();

  const handleCTAClick = () => {
    navigate('/login');
  };

  return (
    <section className="howitworks-section-new" id="how-it-works">
      <div className="howitworks-bg-orb"></div>
      <div className="howitworks-bg-mesh"></div>

      <div className="howitworks-container-new">
        <div className="howitworks-header-section">
          <div className="howitworks-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="1.5"/>
            </svg>
            How It Works
          </div>
          <h2 className="howitworks-main-heading">3 Steps to Mastery</h2>
          <p className="howitworks-subheading">
            From Question to Knowledge in Seconds
          </p>
        </div>

        <div className="howitworks-cards-grid">
          {/* Step 1 */}
          <div className="howitworks-card-new" data-index="1">
            <div className="card-glow-effect"></div>
            <div className="step-number-badge">1</div>
            <div className="howitworks-icon-box">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </div>
            <h3 className="howitworks-card-title">Ask Your Question</h3>
            <p className="howitworks-card-desc">Type any medical question, search for topics, or request information on medications, diseases, or clinical cases using natural language.</p>
            <div className="howitworks-visual">
              <div className="demo-input">
                <span className="input-text">Treatment for Type 2 Diabetes?</span>
                <div className="input-cursor"></div>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="howitworks-card-new" data-index="2">
            <div className="card-glow-effect"></div>
            <div className="step-number-badge">2</div>
            <div className="howitworks-icon-box">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M8 15C12.8747 15 15 12.949 15 8C15 12.949 17.1104 15 22 15C17.1104 15 15 17.1104 15 22C15 17.1104 12.8747 15 8 15Z" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M2 6.5C5.13376 6.5 6.5 5.18153 6.5 2C6.5 5.18153 7.85669 6.5 11 6.5C7.85669 6.5 6.5 7.85669 6.5 11C6.5 7.85669 5.13376 6.5 2 6.5Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </div>
            <h3 className="howitworks-card-title">Get AI-Powered Answers</h3>
            <p className="howitworks-card-desc">Receive instant, evidence-based answers powered by advanced AI models, backed by the latest medical research and clinical guidelines.</p>
            <div className="howitworks-visual">
              <div className="demo-response">
                <div className="response-lines">
                  <div className="resp-line"></div>
                  <div className="resp-line short"></div>
                  <div className="resp-line"></div>
                </div>
                <div className="ai-badge">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z" fill="currentColor"/>
                  </svg>
                  AI Powered
                </div>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="howitworks-card-new" data-index="3">
            <div className="card-glow-effect"></div>
            <div className="step-number-badge">3</div>
            <div className="howitworks-icon-box">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M9 11L12 14L22 4" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </div>
            <h3 className="howitworks-card-title">Study & Master</h3>
            <p className="howitworks-card-desc">Create case studies, save important information, and practice with AI-generated scenarios to master medical knowledge through active learning.</p>
            <div className="howitworks-visual">
              <div className="demo-progress">
                <div className="progress-item">
                  <div className="item-check">✓</div>
                  <div className="item-bar"></div>
                </div>
                <div className="progress-item">
                  <div className="item-check">✓</div>
                  <div className="item-bar"></div>
                </div>
                <div className="progress-item active">
                  <div className="item-check">3</div>
                  <div className="item-bar partial"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="howitworks-cta-wrapper">
          <button className="howitworks-cta-btn" onClick={handleCTAClick}>
            <span>Start Learning Free</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M7 17L17 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M7 7H17V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}

export default HowItWorksSection;
